import { VERTICALS } from '../data/verticals';
import VerticalPage from './VerticalPage';

const Logistics = () => <VerticalPage config={VERTICALS['logistics']} />;

export default Logistics;
